import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-view-document-new",
  templateUrl: "./view-document-new.component.html",
  styleUrls: ["./view-document-new.component.scss"],
})
export class ViewDocumentNewComponent implements OnInit {
  activeLangIndex: number = 0;
  constructor(
    public dialogRef: MatDialogRef<ViewDocumentNewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
  }
}
